export default __webpack_public_path__ + "static/media/check-circle-default.1581205f.svg";